import { render, staticRenderFns } from "./revealFate.vue?vue&type=template&id=5c4752f3&scoped=true&"
import script from "./revealFate.vue?vue&type=script&lang=ts&"
export * from "./revealFate.vue?vue&type=script&lang=ts&"
import style0 from "./revealFate.vue?vue&type=style&index=0&id=5c4752f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4752f3",
  null
  
)

export default component.exports